import WebPageLayout from "../../layouts/WebPageLayout";
import React, { useRef, useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import TablePageLayout from "../../layouts/TablePageLayout";
import { useLazyGetDashboardQuery } from "../../../../store/services/api/dashboard-api";
import DashboardViewFilters from "./DashboardViewFilters";
import { DateTime } from "luxon";
import {
  OrderedListOutlined,
  ClockCircleOutlined,
  ScheduleOutlined,
  HourglassOutlined,
} from "@ant-design/icons";
import { BaseFilters } from "../../../web/hooks/useFilters";
import { WorkOrderStatus, WorkOrderType } from "../../../../store/data/entities/work-order";
import useEntityListPage from "../../hooks/useEntityListPage";
import { StyleSheet, View } from "react-native";

import BuildingMap from "./BuildingMap";
import PreventiveCorrectiveChart from "./PreventiveCorrectiveChart";
import AssetRankBarChart from "./AssetRankBarChart";
import StatusPie from "./StatusPie";
import WorkOrderPerAssetChart from "./AssetTypeBarChart";

interface DashboardViewFilters extends BaseFilters {
  buildingId?: string[];
  buildingLeadId?: string[];
  technicianId?: string[];
  assetTypeId?: string[];
  startDate?: string;
  endDate?: string;
  scheduledFinishStartDate?: string;
  scheduledFinishEndDate?: string;
  createdOnStartDate?: string;
  createdOnEndDate?: string;
  closedOnStartDate?: string;
  closedOnEndDate?: string;
  labourEntryStartDate?: string;
  labourEntryEndDate?: string;
  type?: WorkOrderType[];
  statuses?: WorkOrderStatus[];
}

export default function DashboardView() {
  const {
    filter,
    tableData: dashboardData,
    onSubmitFilter,
  } = useEntityListPage<DashboardViewFilters>({
    entityName: "Dashboard",
    lazyTableQuery: useLazyGetDashboardQuery,
    filterDefinition: {
      sortedColumn: "",
      sortedColumnAscending: false,
      pageNumber: 1,
      pageSize: 50,
      createdOnEndDate: DateTime.now().toISODate(),
      createdOnStartDate: DateTime.now().minus({ days: 7 }).toISODate(),
    },
  });

  const imageData = dashboardData?.imageDto.workOrdersPerBuilding || [];
  console.log("imageData", imageData);

  const PreventiveChartRef = useRef<HTMLDivElement>(null);
  const AssetRankBarRef = useRef<HTMLDivElement>(null);
  const StatusPieRef = useRef<HTMLDivElement>(null);
  const buildingRef = useRef<HTMLDivElement>(null);

  const [AssetRankBarSize, setAssetRankBarSize] = useState({ width: 0, height: 0 });
  const [StatusPieSize, setStatusPieSize] = useState({ width: 0, height: 0 });
  const [buildingSize, setbuildingSize] = useState({ width: 0, height: 0 });
  const [PreventiveChartSize, setPreventiveChartSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
      if (!AssetRankBarRef.current) return;
        const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setAssetRankBarSize({ width, height });
        }
        });
        observer.observe(AssetRankBarRef.current);
        return () => observer.disconnect(); 
      
    }, []);
    useEffect(() => {
      if (!StatusPieRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setStatusPieSize({ width, height });
        }
        });
        observer.observe(StatusPieRef.current);
        return () => observer.disconnect();
  
      
    }, []);
    useEffect(() => {
      if (!PreventiveChartRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setPreventiveChartSize({ width, height });
        }
        });
        observer.observe(PreventiveChartRef.current);
        return () => observer.disconnect();
  
      
    }, []);
    useEffect(() => {
      if (!buildingRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setbuildingSize({width: width, height: height });
        }
        });
        observer.observe(buildingRef.current);
        return () => observer.disconnect();
  
      
    }, []);


  const cards = [
    {
      title: "Total Open WO:",
      value: dashboardData?.dashboardCountDto.openWorkOrders ?? 0,
      icon: <OrderedListOutlined />,
    },
    {
      title: "Overdue WO:",
      value:
        dashboardData?.dashboardCountDto.overDueWorkOrders != null
          ? `${dashboardData.dashboardCountDto.overDueWorkOrders}%`
          : "0%",
      icon: <ClockCircleOutlined />,
    },
    {
      title: "WO Days Open Average:",
      value: dashboardData?.dashboardCountDto.dayOpenAvg ?? 0,
      icon: <ScheduleOutlined />,
    },
    {
      title: "Open Tickets:",
      value: dashboardData?.dashboardCountDto.openTickets ?? 0,
      icon: <HourglassOutlined />,
    },
  ];

  return (
    <WebPageLayout
      header={{
        tabs: [
          { title: "Work Orders", routeName: "workOrders", replaceStack: true },
          { title: "Tickets", routeName: "tickets", replaceStack: true },
          { title: "Job Plans", routeName: "jobPlans", replaceStack: true },
          { title: "Preventative Maintenance", routeName: "preventativeMaintenances", replaceStack: true },
          { title: "System", routeName: "system", replaceStack: true },
        ],
      }}
    >
      <TablePageLayout
        filters={<DashboardViewFilters filter={filter} onSubmit={onSubmitFilter} />}
        actions={null}
        actionsContainerStyle={{ marginBottom: 0 }}
      >
        <View style={styles.container}>
          <div
            style={{ display: "flex", flex: 1, minHeight: 0, alignItems: "center", gap: 8, marginBottom: 8,}}>
            {cards.map((stat, index) => (
              <Card
                key={index}
                bordered
                style={{ borderColor: "blue", flex: 1, minWidth: 120, height: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px 12px"}}>
                <div
                  style={{display: "flex",alignItems: "center",justifyContent: "center",gap: "8px",width: "100%",}}>
                  <span
                    style={{flex: 0,fontSize: "2vw",}}>
                    {stat.icon}
                  </span>
                  <span
                    style={{flex: 1,fontSize: "1vw",fontWeight: 500,whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis",textAlign: "center",}}>
                    {stat.title}
                  </span>
                  <span
                    style={{flex: 0,fontSize: "1vw",fontWeight: 600,}}>
                    {stat.value}
                  </span>
                </div>
              </Card>
            ))}
          </div>


          <div style={{display: "flex", flex: 9, minHeight: 0, gap: 8, }}>
            <div style={{flex: 1.5, display: "flex", flexDirection: "column", minHeight: 0, gap: 8,}}>
              <div style={{display: "flex", flex: 4, gap: 8, minHeight: 0,}}>
                <div style={{flex: 1, display: "flex", flexDirection: "column", minHeight: 0,}}>
                  <div ref={AssetRankBarRef} style={{ ...styles.chartContainer, flex: 1 }}> 
                    <h3 style={{ marginTop: 0, marginBottom: 0 }}>Work Order per Asset Ranking</h3>
                    <AssetRankBarChart
                      data={dashboardData?.dashboardAssetPriorityDto.workOrderPriorityCounts || []}
                      width={AssetRankBarSize?.width}
                      height={AssetRankBarSize?.height}
                    />
                  </div>
                </div>

                <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, }}>
                  <div ref={StatusPieRef} style={{ ...styles.chartContainer, flex: 1 }}>
                    <h3 style={{ marginTop: 0, marginBottom: 0 }}>Work Order per Status</h3>
                    <StatusPie
                      data={dashboardData?.dashboardWorkOrderStatusDto.workOrderStatusCounts || []}
                      width={StatusPieSize?.width}
                      height={StatusPieSize?.height}
                    />
                  </div>
                </div>
              </div>

              <div style={{  flex: 6, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div style={{ ...styles.chartContainer, flex: 1 }}>
                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>#WO x Asset Type</h3>
                  <WorkOrderPerAssetChart
                    data={dashboardData?.dashboardWorkOrderPerAssetDto.workOrdersPerAssetType || []}
                  />
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, gap: 8, }}>
              <div style={{ flex: 8, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div ref={buildingRef} style={{ flex: 1, minHeight: 0,  alignItems: "flex-end",  }}>
                  {buildingSize && (
                    <BuildingMap
                      imageSrc={require("../../../../assets/images/buildings.png")}
                      originalWidth={buildingSize.width}
                      originalHeight={buildingSize.height}
                      buildings={imageData}
                  />
                  )}
                </div>
              </div>

              <div style={{ flex: 2, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div ref={PreventiveChartRef} style={{ ...styles.chartContainer, flex: 1 }}>
                  <PreventiveCorrectiveChart
                    data={
                      dashboardData?.dashboardCorrectivePreventiveDto
                        .dashboardPreventiveCorectiveCounts || []
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </View>
      </TablePageLayout>
    </WebPageLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: 18,
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#CECECE",
    borderRadius: 6,
  },
  chartContainer: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: "visible",
    padding: 8,
    borderRadius: 16,
    border: '2px solid #ccc',
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },
});
